import { TorusTwice } from "@/components/TorusTwice";
import ReactLenis from "lenis/react";

export function TorusPage() {
  return (
    <>
      <ReactLenis
        root
        options={{
          syncTouch: true,
          infinite: true,
        }}
      />
      <div className="text-white flex flex-col items-center justify-center min-h-screen">
        <div className="fixed top-0 left-0 w-screen h-screen z-10">
          <TorusTwice />
          <div className="absolute top-1/2 left-1/2 -translate-1/2 -z-2 w-24 h-24 bg-red-500/50 backdrop-blur-md rounded-full flex items-center justify-center">
            Hi
          </div>
        </div>
      </div>
    </>
  );
}
